<style scoped>
.v-dialog__content {
  justify-content: left;
}
.content-box {
  height: 90px;
  border: 1px solid #cccc;
  cursor: pointer;
  overflow: auto;
  font-size: 12px;
  padding: 4px;
}
h5 {
  font-weight: 700;
  font-size: 12px;
  text-decoration: none;
}
.v-text-field input {
    font-size: 1.2em;
  }
.airwaybill table {
  font-size: 12px;
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;
}
/*** Table Styles **/

.table-fill {
  background: white;
  border-radius:3px;
  border-collapse: collapse;
  margin: auto;
  padding:2px;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  animation: float 5s infinite;
}

th {
  color:#D5DDE5;;
  background:#1b1e24;
  border-bottom:4px solid #9ea7af;
  border-right: 1px solid #343a45;
  font-weight: 100;
  padding:5px;
  text-align:left;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  vertical-align:middle;
}

th:first-child {
  border-top-left-radius:3px;
}

th:last-child {
  border-top-right-radius:3px;
  border-right:none;
}

tr {
  border-top: 1px solid #C1C3D1;
  border-bottom-: 1px solid #C1C3D1;
  color:#666B85;
  font-weight:normal;
  text-shadow: 0 1px 1px rgba(256, 256, 256, 0.1);
}



tr:first-child {
  border-top:none;
}

tr:last-child {
  border-bottom:none;
}

tr:nth-child(odd) td {
  background:#EBEBEB;
}


tr:last-child td:first-child {
  border-bottom-left-radius:3px;
}

tr:last-child td:last-child {
  border-bottom-right-radius:3px;
}

td {
  background:#FFFFFF;
  padding:5px;
  text-align:left;
  vertical-align:middle;
  font-weight:300;
  text-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #C1C3D1;
}

td:last-child {
  border-right: 0px;
}

th.text-left {
  text-align: left;
}

th.text-center {
  text-align: center;
}

th.text-right {
  text-align: right;
}

td.text-left {
  text-align: left;
}

td.text-center {
  text-align: center;
}

td.text-right {
  text-align: right;
}

.v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {
    padding: 0 5px;
}

table input {
  width: 100%;
}
.v-input {
  font-size: 12px !important;
}
.v-card__title {
  padding: 8px 16px !important;
}
.v-card__text {
    padding: 16px !important;
    width: 100%;
}
.v-card__text .container {
    padding: 0  !important;
    width: 100%;
}
</style>
<style>
.v-messages {
    min-height: 0px !important;
}
.v-text-field__details {
    margin-bottom: 0px !important;
}

.airwaybill .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px;
}
.airwaybill .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}
.airwaybill .v-input--selection-controls__input {
    height: 12px;
}
.airwaybill .v-label {
  font-size: 12px;
}
.airwaybill .v-text-field.v-text-field--solo .v-input__control {
  min-height: 10px;
  padding: 0;
}
.airwaybill .v-input__controls {
  max-height: 55px !important;
}
.airwaybill .v-select {
  max-height: 65px !important;
}
</style>
<style lang="scss" rel="stylesheet/scss" scoped>
  .viewer-wrapper {
    position: fixed;
    background: #333;
    height: auto;
  }
  .methods {
    margin-bottom: 1em;
    flex-wrap: wrap;
    & > * {
      margin-right: 0.75rem;
    }
  }
  .options-panel {
    .panel-block {
      padding: 0;
      .checkbox {
        display: block;
        width: 100%;
        margin: 0;
        padding: 0.5em 0.75em;
      }
    }
  }
  .viewer {
    height: 100%;
    .images {
      height: 100%;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 5px;
      .image-wrapper {
        display: inline-block;
        width: calc(33% - 20px);
        margin: 5px 5px 0 5px;
        .image {
          width: 100%;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }
</style>
<template>
  <vue-perfect-scrollbar class="scroll-area" :settings="settings">

<v-container fluid grid-list-md class="airwaybill"  v-if="showForm">
  <h1 v-if="currentDocument">{{ currentDocument.labelsFound }}</h1>
<v-layout row wrap>
  <v-flex xs8>
    <v-layout row wrap>
      <v-flex xs12>
        <h5>Air Waybill Number</h5>
      </v-flex>
      <v-flex xs3>
        <v-autocomplete style="height: 50px;" v-model="form.numberDetail.airlineCode" :items="airlines" item-value="iata_code_mawb" item-text="item_text" label="Airline Code" placeholder=" " outline></v-autocomplete>
      </v-flex>
      <v-flex xs6>
        <v-text-field style="height: 50px;" label="Serial Number"  v-model="form.numberDetail.serialNumber" placeholder=" " outline></v-text-field>
      </v-flex>
    </v-layout>
    <!-- shipper and issuing carrier details -->
    <v-layout row wrap>
      <v-flex xs6>
        <v-flex xs12>
          <!--<h5><v-icon color="green darken-2">edit</v-icon> Shipper's Name And Address</h5>-->
          <h5>Shipper's Name And Address</h5>
          <div class="content-box" v-on:click="shippingDetailsDialog = true; addressDetails = form.shippingDetail;">
            {{ form.shippingDetail.name }} </br>
              {{ form.shippingDetail.address.address }}
          </div>
        </v-flex>
      </v-flex>
      <v-flex xs6>
        <v-flex xs12>
          <h5>Issuing Carrier's Name And Address</h5>
          <div class="content-box" v-on:click="issuingCarrierDetailsDialog = true">
          </div>
        </v-flex>
      </v-flex>
    </v-layout>
    <!-- end shipper and issuing carrier details -->
    <!-- consignee, account, issuing agent -->
    <v-layout row wrap>
      <v-flex xs6>
        <v-flex xs12>
          <!--<h5><v-icon color="green darken-2">edit</v-icon> Shipper's Name And Address</h5>-->
          <h5>Consignee's Name And Address</h5>
          <div class="content-box" v-on:click="shippingDetailsDialog = true; addressDetails = form.consigneesNameAndAddress;" v-html="form.consigneesNameAndAddress.replace(/\r\n/g, '<br />')">

          </div>
        </v-flex>
        <v-flex xs12>
          <!--<h5><v-icon color="green darken-2">edit</v-icon> Shipper's Name And Address</h5>-->
          <v-flex xs12>
          <h5>Issuing Carrier's Agent Name And City</h5>
          <div class="content-box" v-on:click="issuingCarrierAgentDetailsDialog = true; addressDetails = form.issuingCarriersNameAndCity;" v-html="form.issuingCarriersNameAndCity.replace(/\r\n/g, '<br />')">

          </div>
          </v-flex>
          <v-layout row wrap>
            <v-flex xs12><h5>Requested Routing </h5></v-flex>
            <v-flex xs6>
                <v-autocomplete v-model="form.routingDestinationAndChargesDetail.airportOfDeparture" :items="airports" item-value="iata" item-text="item_text" label="Airport Of Departure" placeholder=" " outline></v-autocomplete>
            </v-flex>
            <v-flex xs6>
                <v-autocomplete v-model="form.routingDestinationAndChargesDetail.airportOfDestination" :items="airports" item-value="iata" item-text="item_text" label="Airport Of Destination" placeholder=" " outline></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <table class="form-table">
                <thead>
                  <tr>
                    <th class="column text-xs-left" rowspan="2">Carrier Code</th>
                    <th class="column text-xs-left" rowspan="2">Flight Number</th>
                    <th class="column text-xs-center" colspan="2">Departure</th>
                    <th class="column text-xs-center" colspan="2">Arrival</th>
                  </tr>
                  <tr>
                    <th class="column text-xs-left">Airport/City</th>
                    <th class="column text-xs-left">Date</th>
                    <th class="column text-xs-left">Airport/City</th>
                    <th class="column text-xs-left">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in form.routingDestinationAndChargesDetail.awbRouteEntities">
                    <td class="column text-xs-left" width="10%"><input type="text" v-model="item.carrierCode" /></td>
                    <td class="column text-xs-left"><input type="text" v-model="item.flightNumber" /></td>
                    <td class="column text-xs-center"><input type="text" v-model="item.departureAirportOrCity" /></td>
                    <td class="column text-xs-center">
                      <input type="text" v-model="item.departureDate" />
                    </td>
                    <td class="column text-xs-center"><input type="text" v-model="item.arrivalAirportOrCity" /></td>
                    <td class="column text-xs-center"><input type="text" v-model="item.arrivalDate" /></td>
                  </tr>
                </tbody>

              </table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex xs6>
            <v-flex xs12><h5>Accounting Information</h5></v-flex>
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea label="Description" placeholder=" " v-model="form.accountingInformationDetail.text" outline></v-textarea>
              </v-flex>
            </v-layout>
            <!--
            <v-layout row wrap v-for="item in form.accountingInformation">
              <v-flex xs4>
                <v-select :chips="true" :clearable="true" :small-chips="true" :hide-selected="true" :items="accountingInformationCodes" model="item.code" item-value="code" item-text="description"
 label="Select"></v-select>
              </v-flex>
              <v-flex xs8>
                <v-text-field label="Description" model="item.description" placeholder=" "></v-text-field>
              </v-flex>
            </v-layout>
            -->
            <v-flex xs12><h5>Shipping Details</h5></v-flex>
            <v-layout row wrap>
              <v-flex xs4>
                <v-text-field label="Reference Number" placeholder=" " outline></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field label="Optional Shipping Informtion" placeholder=" " outline></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field label="Optional Shipping Informtion" placeholder=" " outline></v-text-field>
              </v-flex>
            </v-layout>
            <v-flex xs12><h5>Charges Details</h5></v-flex>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete :items="currencies" v-model="form.routingDestinationAndChargesDetail.currency" item-value="code" item-text="description" label="Currency" placeholder=" " outline></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Charges Code" placeholder=" " outline></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-flex xs12><h5>Weight & Valuation Charge</h5></v-flex>
                <v-radio-group v-model="form.routingDestinationAndChargesDetail.weightAndValuationCharge">
                  <v-radio value="PP" label="Prepaid"></v-radio>
                  <v-radio value="COL" label="Collect"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs6>
                <v-flex xs12><h5>Other Charges</h5></v-flex>
                <v-radio-group v-model="form.routingDestinationAndChargesDetail.otherCharges">
                  <v-radio value="PP" label="Prepaid"></v-radio>
                  <v-radio value="COL" label="Collect"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field label="Declared Value For Carriage *" v-model="form.routingDestinationAndChargesDetail.declaredValueForCarriage" placeholder="Enter Amount Or NVD" outline></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Declared Value For Customs *" v-model="form.routingDestinationAndChargesDetail.declaredValueForCustoms" placeholder="Enter Amount Or NCV" outline></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field label="Amount Of insurance *" v-model="form.routingDestinationAndChargesDetail.amountOfInsurance" placeholder="Enter Amount Or XXX" outline></v-text-field>
              </v-flex>
              <v-flex xs6 style="font-size: 9px">
                INSURANCE: If Carrier offers insurance and such insurance is requested in accordance with conditions on reverse hereof, indicate amount to be insured in figures in
box marked “amount of insurance”.
              </v-flex>
            </v-layout>
      </v-flex>
      <!-- handling details row -->
      <v-flex xs8>
        <v-flex xs12><h5>Handling Details</h5></v-flex>
        <v-autocomplete :multiple="true" v-model="form.handlingInformationDetail.codes" :chips="true" :clearable="true" :items="handlingCodes" item-value="code" item-text="description" label="Handling Codes" placeholder=" " outline></v-autocomplete>
      </v-flex>
      <v-flex xs4>
        <v-flex xs12><h5>&nbsp;</h5></v-flex>
        <v-text-field label="SCI" v-model="form.handlingInformationDetail.sci" placeholder=" " outline></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-layout row wrap>
          <v-flex xs12>
            <v-textarea label="SSR : Special Service Request" v-model="form.handlingInformationDetail.specialServiceRequest" placeholder=" " outline></v-textarea>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6>
        <v-layout row wrap>
          <v-flex xs12>
            <v-textarea label="OSI : Other Service Information" v-model="form.handlingInformation.osi" placeholder=" " outline></v-textarea>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs6><h5>Consignment Rating Details</h5></v-flex>
          <v-flex xs6>
            <div class="text-xs-right">
            <v-btn small color="green" class="white--text" v-on:click="setActiveRatingLine(); consignmentRatingDetailsDialog = true;">
              Add Rating Item
            <v-icon right dark>add</v-icon>
            </v-btn>
          </div>
        </v-flex>
        </v-layout>
        <v-flex xs12>
          <table class="">
            <thead>
              <tr>
                <th class="column text-xs-left">No. Of Pieces</th>
                <th class="column text-xs-left">Gross Weight</th>
                <th class="column text-xs-center">KG/LB</th>
                <th class="column text-xs-center">Rate Class Code</th>
                <th class="column text-xs-center">Chargeable Weight</th>
                <th class="column text-xs-center">Rate/Charge</th>
                <th class="column text-xs-center">Total</th>
                <th class="column text-xs-center">Nature And Quantity Of Goods (inc. Dimensions or Volume)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in form.airWaybillTable.airWaybillItems" v-on:click="setActiveRatingLine(item); consignmentRatingDetailsDialog = true;">
                <td class="column text-xs-left">{{ item.numberOfPieces }}</td>
                <td class="column text-xs-left"></td>
                <td class="column text-xs-left"></td>
                <td class="column text-xs-left"></td>
                <td class="column text-xs-left"></td>
                <td class="column text-xs-left"></td>
                <td class="column text-xs-left"></td>
                <td class="column text-xs-left"></td>
              </tr>
            </tbody>

          </table>
        </v-flex>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs6>
            <v-flex xs12><h5>Charge Summary</h5></v-flex>
            <table class="">
              <thead>
                <tr>
                  <th class="column text-xs-center">Prepaid</th>
                  <th class="column text-xs-center">Collect</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2" class="column text-xs-center">Weight Charge</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">0.00</td>
                  <td class="column text-xs-left">0.00</td>
                </tr>
                <tr>
                  <td colspan="2" class="column text-xs-center">Valuation Charge</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">0.00</td>
                  <td class="column text-xs-left">0.00</td>
                </tr>
                <tr>
                  <td colspan="2" class="column text-xs-center">Tax</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">0.00</td>
                  <td class="column text-xs-left">0.00</td>
                </tr>
                <tr>
                  <td colspan="2" class="column text-xs-center">Total Other Charges Due Agent</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">0.00</td>
                  <td class="column text-xs-left">0.00</td>
                </tr>
                <tr>
                  <td colspan="2" class="column text-xs-center">Total Other Charges Due Carrier</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">0.00</td>
                  <td class="column text-xs-left">0.00</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">Total Prepaid</td>
                  <td class="column text-xs-left">Total Collect</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">0.00</td>
                  <td class="column text-xs-left">0.00</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">Currency Conversion Rates</td>
                  <td class="column text-xs-left">CC Charges in Dest. Currency</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">0.00</td>
                  <td class="column text-xs-left">0.00</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">Charges At Destination</td>
                  <td class="column text-xs-left">Total Collect Charges</td>
                </tr>
                <tr>
                  <td class="column text-xs-right">0.00</td>
                  <td class="column text-xs-left">0.00</td>
                </tr>
              </tbody>
            </table>
          </v-flex>
          <v-flex xs6>
            <v-flex xs12><h5>Other Charges</h5></v-flex>
            <table class="form-table">
              <thead>
                <tr>
                  <th class="column text-xs-left">Code</th>
                  <th class="column text-xs-center">Due Agent/Carrier</th>
                  <th class="column text-xs-left">Amount</th>
                </tr>

              </thead>
              <tbody>
                <tr v-for="item in form.airportOfDepartureAndRequestedRouting.details">
                  <td class="column text-xs-left" width="40%">
                    <v-autocomplete :items="otherCharges" item-value="code" item-text="description" label=" "  model="item.code" solo></v-autocomplete>
                  </td>
                  <td class="column text-xs-center" width="40%">
                    <v-radio-group v-model="item.due" row>
                      <v-radio label="Agent" value="agent"></v-radio>
                      <v-radio label="Carrier" value="carrier"></v-radio>
                    </v-radio-group>
                  </td>
                  <td class="column text-xs-center"><input type="text" model="item.amount" /></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>
  </v-flex>
  <v-flex xs4 text-center>
    <!--
    <div class="viewer-wrapper">

          <viewer :options='{zoomable: true, "inline": true, "movable": true}' :images="['https://taybull.s3.eu-west-2.amazonaws.com/textract/project_id_1/238_image.jpg']"
                  @inited="inited"
                  class="viewer" ref="viewer"
          >
            <template slot-scope="scope">
              <figure class="images">
                <div class="image-wrapper">
                  <img src="https://taybull.s3.eu-west-2.amazonaws.com/textract/project_id_1/238_image.jpg" width="100%" />
                </div>
              </figure>
            </template>
          </viewer>
        </div>
      -->

    <div class="viewer-wrapper">
    <div :options="options" class="viewer" ref="viewer">
      <img :src="documentImage" width="100%" @load="startViewer()" />
    </div>
    </div>

  </v-flex>
</v-layout>

<!-- consignment rating details dialog -->
<v-dialog class="airwaybill" v-model="consignmentRatingDetailsDialog" persistent max-width="900px">
    <v-card>
      <v-card-title>
        <span class="headline">Consignment Rating Item</span>
      </v-card-title>
      <v-card-text v-if="activeRatingLine">
        <v-container grid-list-md p-0  class="airwaybill">
          <v-layout row wrap>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12><h5>&nbsp;</h5></v-flex>
                <v-flex xs4>
                  <v-text-field label="No. Of Pieces *" v-model="activeRatingLine.numberOfPieces" required outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="SLAC" v-model="activeRatingLine.slac" required outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="RCP" v-model="activeRatingLine.rcp" required outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="Gross Weight" v-model="activeRatingLine.grossWeight" required outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="Chargeable Weight" v-model="activeRatingLine.chargeableWeight" required outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-select :items="metrics" item-value="code" item-text="description" label="KG/LB"  v-model="activeRatingLine.chargeableWeightKgLb" solo></v-select>
                </v-flex>
                <v-flex xs8>
                  <v-select :items="rateClasses" item-value="code" item-text="description" label="Rate Class"  v-model="activeRatingLine.rateClassCode" solo></v-select>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="Rate Charge" v-model="activeRatingLine.rateCharge" required outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Commodity Item Number" v-model="activeRatingLine.commodityItemNumber" outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Volume" v-model="activeRatingLine.volume" outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="ULD Type" v-model="activeRatingLine.uldType" placeholder=" " outline></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="ULD Serial Number" v-model="activeRatingLine.uldSerialNumber" placeholder=" " outline></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="ULD Owner Code" v-model="activeRatingLine.uldOwnerCode" placeholder=" " outline></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="ULD Rate Class Type" v-model="activeRatingLine.uldRateClassType" placeholder=" " outline></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Harmonised Commodity Code" v-model="activeRatingLine.harmonisedComodityCode" placeholder=" " outline></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>

              <v-flex xs12><h5>Nature And Quantity Of Goods</h5></v-flex>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea label="Description" placeholder=" " outline></v-textarea>
                </v-flex>
                <v-flex xs12><h5>Dimensions</h5></v-flex>
                <v-flex xs12>
                <table class="form-table">
                  <thead>
                    <tr>
                      <th class="column text-xs-left">Length</th>
                      <th class="column text-xs-center">Width</th>
                      <th class="column text-xs-left">Height</th>
                      <th class="column text-xs-left">CM/IN</th>
                      <th class="column text-xs-left">No. Of Units</th>
                    </tr>

                  </thead>
                  <tbody>
                    <tr v-for="item in form.airportOfDepartureAndRequestedRouting.details">
                      <td class="column text-xs-center"><input type="text" model="item.amount" /></td>
                      <td class="column text-xs-center"><input type="text" model="item.amount" /></td>
                      <td class="column text-xs-center"><input type="text" model="item.amount" /></td>
                      <td class="column text-xs-center"><input type="text" model="item.amount" /></td>
                      <td class="column text-xs-center"><input type="text" model="item.amount" /></td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>


              </v-layout>

            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="consignmentRatingDetailsDialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="consignmentRatingDetailsDialog = false; saveRatingLine(activeRatingLine);">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- shipping details dialog -->
  <v-dialog v-model="shippingDetailsDialog" persistent max-width="600px" :hide-overlay="true">
      <v-card>
        <v-card-title>
          <span class="headline">Shipping Details</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Name *" v-model="form.shippingDetail.name" required outline placeholder=" "></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Account Number" outline placeholder=" "></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-textarea label="Address" v-model="form.shippingDetail.address.address" outline placeholder=" ">

                </v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Zip/Postal Code" v-model="form.shippingDetail.address.zipOrPostalCode"  outline placeholder=" "></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Country" v-model="form.shippingDetail.address.country" outline placeholder=" "></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Telephone" v-model="form.shippingDetail.telephone" outline placeholder=" "></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field label="Fax" v-model="form.shippingDetail.fax"  outline placeholder=" "></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="shippingDetailsDialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="shippingDetailsDialog = false">Save</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end shipping details dialog -->
    <!-- issuing carrier details -->
    <v-dialog v-model="issuingCarrierDetailsDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Issuing Carrier Details</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field label="Name *" required outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-textarea label="Address" outline placeholder=" "></v-textarea>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field label="Telephone" outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field label="Fax" outline placeholder=" "></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="issuingCarrierDetailsDialog = false">Close</v-btn>
            <v-btn color="blue darken-1" flat @click="issuingCarrierDetailsDialog = false">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end issuing carrier details -->
      <!-- issuing carrier agent details -->
      <v-dialog v-model="issuingCarrierAgentDetailsDialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Issuing Carrier's Agent Details</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Name *" required outline placeholder=" "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-textarea label="Address" v-model="addressDetails" outline placeholder=" "></v-textarea>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Agents IATA Code" v-model="form.agentsIATACode" outline placeholder=" "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Account Number" v-model="form.accountNo" outline placeholder=" "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="CASS Address" v-model="form.cassAddress" outline placeholder=" "></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-checkbox label="Commissionable" type="checkbox"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="issuingCarrierAgentDetailsDialog = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="issuingCarrierAgentDetailsDialog = false">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- end issuing carrier agent details -->
</v-container>
</vue-perfect-scrollbar>
</template>

<script>

import ApiService from '@/services/api.service';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import {getFromStorage, saveInStorage, removeFromStorage, clearStorage} from '@/services/localstorage.service';
import {createNamespacedHelpers} from 'vuex';
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('charts');

import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
//import Viewer from 'v-viewer';
//import Vue from 'vue';
//Vue.use(Viewer);

//
let ratingLineDimensionTemplate = {length: null, width: null, height: null, metric: null, numberOfUnits: null};
export default {
    name: 'awb-form',
    data: function() {
      return {
        settings: {
          maxScrollbarLength: 60
        },
        showForm: false,
        documentData: {},
        viewer: null,
        documentImage: null,
        options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": false, "keyboard": false },
        menu: false,
        currentDocument: null,
        currentFile: null,
        imageUrl: "https://taybull.s3.eu-west-2.amazonaws.com/textract/project_id_1/",
        accountingInformationCodes: [
          {code: "GBL", description: "GBL - Government Bill Of Lading"},
          {code: "GEN", description: "GEN - General Information"},
          {code: "MCO", description: "MCO - Misc Charge Of Order"},
          {code: "RET", description: "RET - Return To Origin"},
          {code: "SRN", description: "SRN - Shipper Reference Number"},
          {code: "STL", description: "STL - Mode Of Settlement"}
        ],
        consignmentRatingDetailsDialog: false,
        shippingDetailsDialog: false,
        addressDetails: "",
        issuingCarrierDetailsDialog: false,
        issuingCarrierAgentDetailsDialog: false,
        airlines: [],
        handlingCodes: [],
        currencies: [],
        rateClasses: [],
        metrics: [
          {code: "kg", description: "KG"},
          {code: "lb", description: "LB"}
        ],
        otherCharges: [],
        ratingLineDimensionTemplate: ratingLineDimensionTemplate,
        activeRatingLine: null,
        selectedRatingLine: null,
        ratingLineTemplate: {
          added: false,
          numberOfPieces: 0,
          slac: null,
          rcp: null,
          grossWeight: null,
          grossWeightKgLb: null,
          rateClassCode: null,
          commodityItemNumber: null,
          rateClassPercentage: null,
          volume: null,
          mc: null,
          volumetricWeight: null,
          volumetricWeightKgLb: null,
          chargeableWeight: 0.00,
          chargeableWeightKgLb: null,
          rateCharge: 0.00,
          totalAmount: null,
          rateAsAgreed:null,
          goodsDescription: null,
          dimensions: [],
          uldType: null,
          uldSerialNumber: null,
          uldOwnerCode: null,
          uldRateClassType: null,
          harmonisedComodityCode: null
        },
        form: null,
        form2: null,
        form1: {
          airlineCode: "",
          airportCode: "",
          serialNumber: "",
          shippersNameAndAddress: "",
          consigneesNameAndAddress: "",
          issuingCarriersNameAndCity: "",
          shippersDetails: {
            name: "",
            accountNumber: "",
            addressLines: "",
            postCode: "",
            telephoneNumber: "",
            faxNumber: ""
          },
          issuingCarrierDetails: {
            name: "",
            accountNumber: "",
            addressLines: "",
            postCode: "",
            telephoneNumber: "",
            faxNumber: ""
          },
          consigneeDetails: {
            name: "",
            accountNumber: "",
            addressLines: "",
            postCode: "",
            telephoneNumber: "",
            faxNumber: ""
          },
          issuingCarrierAgentDetails: {
            name: "",
            accountNumber: "",
            iataCode: "",
            cassAddress: "",
            commissionable: false,
            addressLines: "",
            postCode: "",
            telephoneNumber: "",
            faxNumber: ""
          },
          accountingInformation: "",
          airportOfDepartureAndRequestedRouting: {
            airportOfDeparture: "",
            airportOfDestination: "",
            details: [
              {
                carrierCode: "",
                flightNumber: "",
                departureAirportOrCity: "",
                departureDate: "",
                arrivalAirportOrCity: "",
                arrivalDate: ""
              },
              {
                carrierCode: "",
                flightNumber: "",
                departureAirportOrCity: "",
                departureDate: "",
                arrivalAirportOrCity: "",
                arrivalDate: ""
              },
              {
                carrierCode: "",
                flightNumber: "",
                departureAirportOrCity: "",
                departureDate: "",
                arrivalAirportOrCity: "",
                arrivalDate: ""
              },
              {
                carrierCode: "",
                flightNumber: "",
                departureAirportOrCity: "",
                departureDate: "",
                arrivalAirportOrCity: "",
                arrivalDate: ""
              },
              {
                carrierCode: "",
                flightNumber: "",
                departureAirportOrCity: "",
                departureDate: "",
                arrivalAirportOrCity: "",
                arrivalDate: ""
              },
              {
                carrierCode: "",
                flightNumber: "",
                departureAirportOrCity: "",
                departureDate: "",
                arrivalAirportOrCity: "",
                arrivalDate: ""
              }
            ]
          },
          shippingInformation: {
            referenceNumber: "",
            optionalShippingInformation: ""
          },
          chargesInformation: {
            currency: "",
            chargesCode: "",
            weightAndValuationChargePPCol: "", // Prepaid (PPD) or Collect COLL
            otherChargePPCol: "", // Prepaid (PPD) or Collect COLL
            declaredValueForCarriage: "", // placeholder Enter amount or NVD
            declaredValueForCustoms: "",
            amountOfInsurance: "" // Enter amount or XXX
          },
          handlingInformation: {
            description: "",
            specialHandlingCodes: [],
            sci: "",
            alsoNotify: "",
            ssr: "",
            osi: ""
          },
          consignmentRatingDetails: {

            items: []
          },
          otherCharges: {
            details: [
              {
                code: "",
                due: "",
                amount: 0.00
              }
            ]
          }

        },
        airports: []
      }
    },
    components: {},
    computed: {
      ...mapState(['parameterisedFilterObject'])
    },
    methods: {
      inited (viewer) {
        console.log("inited");
        this.$viewer = viewer
        this.$viewer.reset = function() {
          return false;
        }
      },
      setActiveRatingLine: function(ratingLine) {
        if(typeof ratingLine == "undefined") {
          ratingLine = this.createRatingLine();
        } else  {
          ratingLine.added = true;
        }

        console.log(ratingLine);

        this.selectedRatingLine = {...ratingLine};
        this.activeRatingLine = ratingLine;

      },
      createRatingLine: function() {
        let ratingLine = {...this.ratingLineTemplate};
        this.addRatingLineDimension(ratingLine);
        return ratingLine;
      },
      addRatingLineDimension: function(ratingLine) {
        ratingLine.dimensions.push({...this.ratingLineDimensionTemplate});
      },
      saveRatingLine: function(ratingLine) {
        if(typeof ratingLine.added != "undefined" && ratingLine.added == true) {
          this.activeRatingLine = {...ratingLine};
        } else {
          this.addRatingLine(this.form, {...ratingLine});
        }
      },
      addRatingLine: function(form, item) {
        form.consignmentRatingDetails.items.push(item);
      },
      loadForm: function(form, doc) {

        this.showForm = true;
        this.form = doc;
        console.log(doc.numberDetail);
        this.form2 = doc;
        //this.form2.numberDetail.serialNumber = doc.numberDetail.serialNumber;
        return;
        console.log("loadForm", this.accountingInformationCodes);

        console.log("doc", doc);

        form = doc;
        console.log("loadForm");

        console.log("form.numberDetail.airlineCode", this.form.numberDetail.airlineCode);
        this.form.numberDetail.serialNumber = doc.numberDetail.serialNumber;
        form.numberDetail.serialNumber = doc.numberDetail.serialNumber;
      //  if(form.consignmentRatingDetails.items.length == 0) {
      //    this.addRatingLine(form, this.createRatingLine());
      //  }

        // form.airlineCode = doc.airlineCode;
        // form.serialNumber = doc.serialNumber;
        // form.shippersNameAndAddress = doc.shippersNameAndAddress;
        // form.consigneesNameAndAddress = doc.consigneesNameAndAddress;
        // form.issuingCarriersNameAndCity = doc.issuingCarriersNameAndCity;
        // form.accountingInformation = doc.accountingInformation;
        //
        // form.airportOfDepartureAndRequestedRouting.airportOfDeparture = doc.airportCode;
        //
        // form.agentsIATACode = doc.agentsIATACode;
        // form.cassAddress = doc.cassAddress;
        // form.accountNo = doc.accountNo;
        //
        // form.currency = doc.currency;
        //
        // form.chargesInformation.weightAndValuationChargePPCol = doc.weightAndValuationChargePPCol;
        // form.chargesInformation.currency = doc.currency;
        // form.chargesInformation.otherChargePPCol = doc.otherChargePPCol;
        // form.chargesInformation.amountOfInsurance = doc.amountOfInsurance;
        // form.chargesInformation.declaredValueForCarriage = doc.declaredValueForCarriage;
        // form.chargesInformation.declaredValueForCustoms = doc.declaredValueForCustoms;
        //
        // form.sci = doc.sci;
        //
        // form.airportOfDepartureAndRequestedRouting.airportOfDestination = doc.to1;
        // if(doc.to2) {
        //   form.airportOfDepartureAndRequestedRouting.airportOfDestination = doc.to2;
        // }
        // if(doc.to3) {
        //   form.airportOfDepartureAndRequestedRouting.airportOfDestination = doc.to3;
        // }
        //
        //
        // form.handlingInformation.ssr = doc.handlingInformation;
        // form.handlingInformation.specialHandlingCodes = doc.specialHandlingCodes;
        // form.handlingInformation.sci = doc.sci;

        // if(doc.otherChargePPCol)



        console.log("form", this.form);
      },
      startViewer: function() {
        if(this.viewer) {
          this.viewer.destroy();
        }
        this.viewer = new Viewer(this.$refs.viewer, this.options);
      },
      loadFile: function(id) {
        let url = "/ocr/file/" + id;
        let that = this;
        let params = {};
        ApiService.query(url, {
          params: params
        }).then(function(response) {
          that.currentFile = response.data;
          that.documentImage = that.imageUrl + that.currentFile.id + '_' + that.currentFile.name;
          that.startViewer();
          console.log("that.currentFile", that.currentFile);
        }).catch(function(error) {

        });
      },
      loadItem: function(id) {
        let url = "/ocr/" + id + "/document/a";
        let that = this;
        let params = {};
        console.log(url);

        this.showForm = false;

        ApiService.query(url, {
          params: params
        }).then(function(response) {
          that.currentDocument = response.data;
          console.log("that.currentDocument", that.currentDocument);
          that.loadForm(that.form, that.currentDocument);
          // that.setData();

        }).catch(function(error) {

        });
      },
      load: function(id, sql, holder) {
        let params = {};
        let that = this;
        params.sql = window.btoa(sql);
        params.pre = 1;
        params.totalItems = 10000;
        params.rowsPerPage = 10000;

        let localCopy = getFromStorage(id);
        if(typeof localCopy != "undefined" && localCopy && localCopy != "undefined") {
          holder = JSON.parse(localCopy);
            that[id] = holder;
            // console.log("holder", holder);
            return false;
        }

        ApiService.query('/datasource/sql/' + 979, {
          params: params
        }).then(function(response) {
          try {


            holder = response.data.results;
            that[id] = holder;

            saveInStorage(id, JSON.stringify(holder));
            console.log("saved", holder)
          } catch(err) {

          }

        }).catch(function(error) {

        });
      }

    },
    mounted: function() {

        let id =  typeof this.$route.params.id != null ? this.$route.params.id : null;

        if(id) {
          let airportSQL = "SELECT concat_ws(' - ', iata, name) as item_text, * FROM airport_airlines_airports_979 WHERE iata IS NOT NULL  ORDER BY iata ASC";
          let airlineSQL = "SELECT concat_ws(' - ', iata_code_mawb, iata_code, iata_airlines) as item_text, * FROM airport_airlines_airlines_979 ORDER BY iata_code_mawb ASC";
          let handlingCodesSQL = "SELECT code, code AS description FROM handling_codes_list_986";
          let currenciesSQL = "SELECT code, concat_ws(' ', symbol, code, description) AS description FROM currencies_list_987";
          let rateClassSQL = "SELECT code, concat_ws(' - ', code, description) AS description FROM rate_card_list_988";
          let otherChargesSQL = "SELECT code,  concat_ws(' - ', code, description) AS description FROM other_charges_list_989";

          this.load("airports", airportSQL, this.airports);
          this.load("airlines", airlineSQL, this.airlines);
          this.load("handlingCodes", handlingCodesSQL, this.handlingCodes);
          this.load("currencies", currenciesSQL, this.currencies);
          this.load("rateClasses", rateClassSQL, this.rateClasses);
          this.load("otherCharges", otherChargesSQL, this.otherCharges);

          this.loadItem(id);
          this.loadFile(id);
        }


    }
}

</script>
